/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var NotificationCenterType;
(function (NotificationCenterType) {
    NotificationCenterType["STORE_AVAILABILITY_SUMMARY"] = "STORE_AVAILABILITY_SUMMARY";
    NotificationCenterType["STORE_PERFORMANCE_SUMMARY"] = "STORE_PERFORMANCE_SUMMARY";
    NotificationCenterType["CHARGEBACKS_SUMMARY"] = "CHARGEBACKS_SUMMARY";
    NotificationCenterType["ITEM_ERROR_RATE"] = "ITEM_ERROR_RATE";
    NotificationCenterType["ITEM_AVG_RATING"] = "ITEM_AVG_RATING";
    NotificationCenterType["ITEM_ERROR_REVIEWS"] = "ITEM_ERROR_REVIEWS";
    NotificationCenterType["BNAME_ERROR_RATE"] = "BNAME_ERROR_RATE";
    NotificationCenterType["BNAME_AVG_RATING"] = "BNAME_AVG_RATING";
    NotificationCenterType["BNAME_ERROR_REVIEWS"] = "BNAME_ERROR_REVIEWS";
    NotificationCenterType["BNAME_DOWNTIME"] = "BNAME_DOWNTIME";
    NotificationCenterType["BNAME_SALES"] = "BNAME_SALES";
    NotificationCenterType["DIGITAL_STORE_COUNT"] = "DIGITAL_STORE_COUNT";
    NotificationCenterType["UNMAPPED_STORES"] = "UNMAPPED_STORES";
    NotificationCenterType["ACCOUNTING_PUSH"] = "ACCOUNTING_PUSH";
    NotificationCenterType["COMPANY_LOST_ACCESS"] = "COMPANY_LOST_ACCESS";
    NotificationCenterType["UNMAPPED_ACCOUNTING_COMPANIES"] = "UNMAPPED_ACCOUNTING_COMPANIES";
})(NotificationCenterType || (NotificationCenterType = {}));
